import React, { useState, useEffect } from 'react';
import { IModifierTemplateItem, IGetAvailableModifiersResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getAvailableModifiers } from 'backend/modifierGroups';
import { MultipleSelect } from './MultipleSelect';
import { DnDList } from './DnDList';
import style from './ModifiersMultipleSelect.module.scss';

interface IProps {
	setModifiers: (value: string[]) => void;
	setModifiersWithAdditionalData: (value: IModifierTemplateItem[]) => void;
	modifiers: string[];
	modifiersWithAdditionalData: IModifierTemplateItem[];
	customerId?: string;
}

export const ModifiersMultipleSelect: React.FC<IProps> = React.memo(
	({ setModifiers, setModifiersWithAdditionalData, modifiers, modifiersWithAdditionalData, customerId }) => {
		const [isFirstRender, setIsFirstRender] = useState(true);

		const { response, loading, refetch, responseError } = useFetchData<IGetAvailableModifiersResponse, string>(
			customerId ? getAvailableModifiers : null,
			customerId as string,
		);

		useEffect(() => {
			if (!isFirstRender) {
				refetch();
			} else {
				setIsFirstRender(false);
			}
		}, [customerId]);

		const handleSetModifiers = (value: string[]) => {
			const updatedModifiersWithAdditionalData = value.map((modifierId) => {
				const modifierFromPreviousState = modifiersWithAdditionalData.find((exist) => exist.id === modifierId);

				const foundModifier = response?.products.find((product) => product.id === modifierId);

				const newModifier: IModifierTemplateItem = {
					id: modifierId,
					name: foundModifier?.name || '-',
					externalId: '',
				};
				return modifierFromPreviousState ? modifierFromPreviousState : newModifier;
			});

			setModifiers(value);
			setModifiersWithAdditionalData(updatedModifiersWithAdditionalData);
		};

		return (
			<div className={style.container} data-test="ModifiersMultipleSelect">
				<MultipleSelect
					data={response?.products || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					setModifiers={handleSetModifiers}
					modifiers={modifiers}
				/>
				<DnDList
					setModifiers={setModifiers}
					setModifiersWithAdditionalData={setModifiersWithAdditionalData}
					modifiers={modifiers}
					modifiersWithAdditionalData={modifiersWithAdditionalData}
				/>
			</div>
		);
	},
);
